import React, { useContext } from 'react'

import { useCanary } from '@bill/canary.react'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormContext, FormPhoneInput, FormTextInput } from '@divvy-web/skylab.form'
import Icon, { ICON_SIZE_SMALL } from '@divvy-web/skylab.icon'
import { TextInputProps } from '@divvy-web/skylab.textinput'

import { isPhoneNumberVerified } from '@sputnik/components/utils'

interface PhoneNumberInputProps extends Omit<TextInputProps, 'name'> {
  inputId: string
  label: React.ReactNode
  showPhoneVerificationIcon?: boolean
}

const PhoneNumberInput = ({ inputId, showPhoneVerificationIcon, label, ...rest }: PhoneNumberInputProps) => {
  const { getFormValue } = useContext(FormContext)
  const [_, makeTestId] = useNameFormatter(inputId)
  const showMfaLogic = useCanary('show-mfa-logic')
  const shouldShowPhoneVerificationIcon = showMfaLogic && showPhoneVerificationIcon

  const getPhoneVerifiedIcon = () => {
    if (!shouldShowPhoneVerificationIcon || !isPhoneNumberVerified(getFormValue)) {
      return
    }

    return (
      <Icon
        name='check'
        size={ICON_SIZE_SMALL}
      />
    )
  }

  const { readOnly, disabled, alwaysShowError } = rest

  if (readOnly) {
    return (
      <FormTextInput
        alwaysShowError={alwaysShowError}
        dataTestId={makeTestId('form-field')}
        disabled={disabled}
        label={label}
        name={inputId}
        readOnly={readOnly}
        rightIcon={getPhoneVerifiedIcon()}
        {...rest}
      />
    )
  }

  return (
    //@ts-expect-error
    <FormPhoneInput
      alwaysShowError={alwaysShowError}
      dataTestId={makeTestId('form-field')}
      disabled={disabled}
      label={label}
      name={inputId}
      readOnly={readOnly}
      rightIcon={getPhoneVerifiedIcon()}
      {...rest}
    />
  )
}

export default PhoneNumberInput
